import { useSelector } from "react-redux";
import {Image} from '@/lib/target';
import MatchHeader from '../MatchHeader';
import MatchServices from "@/services/MatchServices";
const Match = async ({ matchId }) => {
  
  const match = await MatchServices.getMatchById(matchId)

  return (
    (match && (
      
    <div className="flex justify-between @lg:justify-center p-4 @md:mb-5">
      <div className="flex flex-col items-center justify-center dark:text-league-dark-detail w-100 @md:w-160">
        <div className="w-40 @md:w-80">
          <Image
            src={match?.homeTeam?.logo || 'https://demofree.sirv.com/nope-not-here.jpg'}
            alt={"Net88"}
            layout="responsive"
            width={40}
            height={40}
            sizes="(max-width: 640px) 100px, (max-width: 1024px) 150px, 200px"
            priority={true}
          />
        </div>
        <p className="text-sm @md:text-base font-semibold text-center mt-6 text-dark-gray dark:text-stroke-o3">{match?.homeTeam?.name}</p>
      </div>
      <MatchHeader matchDB={match}/>
      {/* <div className="text-center p-2">
        <div className=" text-xxs @md:text-xs mb-2 dark:text-league-dark-detail font-semibold">
          {match.league && match.league.name} 
          <span className='mx-1 @md:mx-2'>|</span> 
          Vòng {match.round} 
          <span className='mx-2 hidden @md:inline-block'>|</span>  
          <span className='dark:text-league-dark-detail hidden @md:inline-block'>{momenttz.unix(match.matchTime).tz('Asia/Ho_Chi_Minh').format("DD-MM-YYYY")}</span> 
        </div>
        <div className="text-xxs @md:text-xs font-bold whitespace-nowrap">
          <span className='text-vibrant-red dark:text-golden-yellow'>{momenttz.unix(match.matchTime).tz('Asia/Ho_Chi_Minh').format("HH:mm")} (GMT +7)</span> 
          <span className='mx-1 @md:hidden'>|</span> 
          <span className='dark:text-league-dark-detail @md:hidden text-wrap'>{momenttz.unix(match.matchTime).tz('Asia/Ho_Chi_Minh').format("DD-MM-YYYY")}</span> 

        </div>

        <div className="flex items-center justify-center mt-2">
          <span className="text-2xl font-semibold text-dark-gray dark:text-league-dark-detail"><MatchScore matchDB={match} score={'homeScore'}/></span>
          <span className="text-gray-500 mx-4 text-sm dark:text-league-dark-detail"><MatchMinute matchId={match.id}/></span>
          <span className="text-2xl font-semibold text-dark-gray dark:text-league-dark-detail"><MatchScore matchDB={match} score={'awayScore'}/></span>
        </div>

        <div className="text-gray-500 text-xs dark:text-blur-gray">
          <span>
            <span>(<MatchScore matchId={match.id} score={'homeHalfScore'}/></span>
            <span>-</span>
            <span><MatchScore matchId={match.id} score={'awayHalfScore'}/></span>
          </span>
          <span>, </span>
          <span>
            <span><MatchScore matchId={match.id} score={'homeScore'}/></span>
            <span>-</span>
            <span><MatchScore matchId={match.id} score={'awayScore'}/>)</span>
          </span>
        </div>
      </div> */}

      <div className="flex flex-col items-center justify-center dark:text-league-dark-detail w-100 @md:w-160">
        <div className="w-40 @md:w-80">
          <Image
            src={match?.awayTeam?.logo || 'https://demofree.sirv.com/nope-not-here.jpg'}
            alt={"Net88"}
            layout="responsive"
            width={40}
            height={40}
            sizes="(max-width: 640px) 100px, (max-width: 1024px) 150px, 200px"
            priority={true}
          />
        </div>
        <p className="text-sm @md:text-base font-semibold text-center mt-6 text-dark-gray dark:text-stroke-o3">{match?.awayTeam?.name}</p>
      </div>
    </div>
    ))
  );
};

const MatchLabel = ({ label }) => {
  return (
    <div className="flex items-center bg-button-blue-bet dark:bg-black text-white-half dark:text-white-half font-semibold rounded w-full px-3 py-1 text-sm">
      {label}
    </div>
  );
}

export { Match, MatchLabel };